// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3gSRI","label":"Labeled_label__1Z3_b","divider":"Labeled_divider__13zOH"};